import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import CGV from "./pages/CGV";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import SocialNetworks from "./pages/SocialNetworks";
import CreateProduct from "./pages/CreateProduct";
import Commandes from "./pages/Commandes";
import ProjectDetails from "./pages/ProjectDetails";
import FAQ from "./pages/FAQ";
import QuiSommesNous from "./pages/QuiSommesNous";

const queryClient = new QueryClient();

const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, [location]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToAnchor />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/mentions_legales" element={<MentionsLegales />} />
          <Route path="/politique_confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogArticle />} />
          <Route path="/social-networks" element={<SocialNetworks />} />
          <Route path="/create_book" element={<CreateProduct />} />
          <Route path="/commandes" element={<Commandes />} />
          <Route path="/project/:id" element={<ProjectDetails />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/qui_sommes_nous" element={<QuiSommesNous />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
